import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {HomeRounded, SettingsApplicationsRounded, PhonelinkSetupRounded, AddToHomeScreenRounded } from '@material-ui/icons';
import adminlogo from '../Dashboard/image/SBS_Logo.png';
import DashboardFragment from '../Dashboard/Fragments/DashboardFragments';
import AddProduct from '../Dashboard/Fragments/AddProduct';
import Enquiry from '../Dashboard/Fragments/Enquiry';
import { useHistory } from 'react-router';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const [fragment, setFragment] = useState("DASHBOARD")

  const loadFragment = () =>{
    switch (fragment) {
      case "DASHBOARD":
        return <DashboardFragment />
      case "ENQUIRY":
        return <Enquiry/>

      case "ADD_PRODUCT":
        return <AddProduct />

      default:
        break;
    }
  }
const history = useHistory();
  const logOut =() =>{
    localStorage.clear();
    history.push('/login')
  }
  

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap>
            <img src={adminlogo} width="200px" borderRadius="20px" alt="logo" />
          </Typography>
         
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Toolbar />
        <div className={classes.drawerContainer}>
          <List>
            <ListItem button onClick={e=>setFragment("DASHBOARD")} >
                <ListItemIcon>
                    <HomeRounded/>
                    </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>
              <Divider />
            <ListItem button onClick={e=>setFragment("ENQUIRY")} >
                <ListItemIcon>
                    <AddToHomeScreenRounded/>
                    </ListItemIcon>
                <ListItemText primary="Enquiry" />
              </ListItem>
            <ListItem button onClick={e=>setFragment("ADD_PRODUCT")}>
                <ListItemIcon>
                    <PhonelinkSetupRounded/>
                    </ListItemIcon>
                <ListItemText primary="Products" />
              </ListItem>
            <ListItem button onClick={logOut}>
                <ListItemIcon>
                    <SettingsApplicationsRounded/>
                    </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItem>

          </List>
          <Divider />
          
        </div>
      </Drawer>
      <main className={classes.content}>
        <Toolbar />
        {loadFragment()}
      </main>
    </div>
  );
}



